(function () {
  'use strict';

  var POLICIES = [
    {
      handle: 'shipping-policy', title: 'Shipping Policy', icon: '&#128666;',
      headline: "Free shipping, clear timelines. Here&#39;s exactly how we deliver.",
      sub: "Every order ships free within the USA. Find processing times, delivery estimates, and common shipping questions below."
    },
    {
      handle: 'refund-policy', title: 'Refund Policy', icon: '&#128260;',
      headline: "Exchanges made easy. Here&#39;s how we make it right.",
      sub: "We stand behind every product we sell. If something arrives damaged or incorrect, we&#39;ll make it right."
    },
    {
      handle: 'privacy-policy', title: 'Privacy Policy', icon: '&#128274;',
      headline: "Your privacy matters. Here&#39;s how we handle your information.",
      sub: "This page explains what information we collect, how we use it, and the choices you have. We keep it simple and honest."
    },
    {
      handle: 'terms-of-service', title: 'Terms of Service', icon: '&#128203;',
      headline: "Clear rules, no surprises. Here are our terms of service.",
      sub: "These terms govern your use of FurryFable.com. By shopping with us you agree to these terms."
    }
  ];

  function getCurrentHandle() {
    var parts = window.location.pathname.split('/');
    return parts[parts.length - 1] || '';
  }

  function getMeta(handle) {
    for (var i = 0; i < POLICIES.length; i++) {
      if (POLICIES[i].handle === handle) return POLICIES[i];
    }
    return { handle: handle, title: 'Policy', icon: '&#128196;', headline: 'Policy details.', sub: '' };
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function headingLevel(el) {
    return parseInt(el.tagName.charAt(1), 10);
  }

  /**
   * Choose the best heading tag to split on.
   * Priority: h2 → h3 → h4. Requires ≥2 headings with text longer than 2 chars.
   */
  function chooseSplitTag(root) {
    var tags = ['h2', 'h3', 'h4'];
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      var all = Array.prototype.slice.call(root.querySelectorAll(tag));
      var meaningful = all.filter(function (el) {
        return el.textContent.trim().length > 2;
      });
      if (meaningful.length >= 2) {
        return { tag: tag, level: parseInt(tag.charAt(1), 10), headings: meaningful };
      }
    }
    return null;
  }

  function buildCards(bodyHTML) {
    var tmp = document.createElement('div');
    tmp.innerHTML = bodyHTML;

    var split = chooseSplitTag(tmp);
    var tocLinks = '<a href="#ffp-top" class="ffp-toc-link">Overview</a>';

    if (!split) {
      // No usable headings: single card with all content (hide any h1 inside)
      return {
        cardsHTML: '<section class="ffp-section-card"><div class="ffp-card-body rte">' + bodyHTML + '</div></section>',
        tocLinks: tocLinks
      };
    }

    var targetLevel = split.level;
    var firstHeading = split.headings[0];

    // Collect intro nodes: everything before the first meaningful heading
    var introNodes = [];
    var node = tmp.firstChild;
    while (node && node !== firstHeading) {
      // Skip h1 (repeated title) and the garbage headings (text ≤ 2 chars)
      var skip = false;
      if (node.nodeType === 1) {
        if (node.tagName === 'H1') skip = true;
        if (/^H[1-6]$/.test(node.tagName) && node.textContent.trim().length <= 2) skip = true;
      }
      if (!skip) introNodes.push(node.cloneNode(true));
      node = node.nextSibling;
    }

    // Build sections from each meaningful heading + its following siblings
    var sections = [];
    split.headings.forEach(function (h) {
      var sec = { title: h.textContent.trim(), nodes: [] };
      var n = h.nextSibling;
      while (n) {
        if (n.nodeType === 1 && /^H[1-6]$/.test(n.tagName)) {
          var nLevel = headingLevel(n);
          // Stop at same-level or higher heading
          if (nLevel <= targetLevel) break;
        }
        sec.nodes.push(n.cloneNode(true));
        n = n.nextSibling;
      }
      sections.push(sec);
    });

    var cardsHTML = '';

    // Intro card (if content exists before first heading)
    if (introNodes.length) {
      var introWrap = document.createElement('div');
      introNodes.forEach(function (n) { introWrap.appendChild(n.cloneNode(true)); });
      var introTrimmed = introWrap.innerHTML.replace(/^\s+|\s+$/g, '');
      if (introTrimmed) {
        cardsHTML += '<section class="ffp-section-card ffp-intro-card">' +
          '<div class="ffp-card-body rte">' + introTrimmed + '</div>' +
          '</section>';
      }
    }

    // Numbered section cards
    sections.forEach(function (sec, i) {
      var num = pad(i + 1);
      var slug = 'ffp-sec-' + i;
      var wrap = document.createElement('div');
      sec.nodes.forEach(function (n) { wrap.appendChild(n.cloneNode(true)); });

      cardsHTML +=
        '<section class="ffp-section-card" id="' + slug + '">' +
          '<div class="ffp-card-header">' +
            '<span class="ffp-card-num">' + num + '</span>' +
            '<h2 class="ffp-card-title">' + sec.title + '</h2>' +
          '</div>' +
          '<div class="ffp-card-body rte">' + wrap.innerHTML + '</div>' +
        '</section>';
      tocLinks += '<a href="#' + slug + '" class="ffp-toc-link">' + sec.title + '</a>';
    });

    return { cardsHTML: cardsHTML, tocLinks: tocLinks };
  }

  function buildPoliciesNav(currentHandle) {
    return POLICIES.map(function (pol) {
      var active = pol.handle === currentHandle ? ' is-active' : '';
      return '<a href="/policies/' + pol.handle + '" class="ffp-policy-link' + active + '">' +
        pol.icon + ' ' + pol.title + '</a>';
    }).join('');
  }

  function init() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container) return;

    var bodyEl = container.querySelector('.shopify-policy__body .rte') ||
                 container.querySelector('.shopify-policy__body');
    if (!bodyEl) return;

    var currentHandle = getCurrentHandle();
    var meta = getMeta(currentHandle);
    var built = buildCards(bodyEl.innerHTML);
    var polNav = buildPoliciesNav(currentHandle);

    var html =
      '<div class="ffp-wrap" id="ffp-top">' +

        '<section class="ffp-hero">' +
          '<div class="ffp-hero-inner">' +
            '<p class="ffp-eyebrow">' + meta.icon + ' ' + meta.title + '</p>' +
            '<h1 class="ffp-hero-title">' + meta.headline + '</h1>' +
            '<p class="ffp-hero-sub">' + meta.sub + '</p>' +
            '<p class="ffp-hero-date">Last reviewed: May 2026</p>' +
          '</div>' +
        '</section>' +

        '<div class="ffp-grid">' +
          '<aside class="ffp-sidebar">' +
            '<div class="ffp-sidebar-card">' +
              '<p class="ffp-sidebar-heading">On this page</p>' +
              '<nav class="ffp-toc" aria-label="Contents">' + built.tocLinks + '</nav>' +
            '</div>' +
            '<div class="ffp-sidebar-card ffp-sidebar-policies">' +
              '<p class="ffp-sidebar-heading">All Policies</p>' +
              polNav +
            '</div>' +
          '</aside>' +
          '<article class="ffp-article">' + built.cardsHTML + '</article>' +
        '</div>' +

        '<div class="ffp-contact-strip">' +
          '<div class="ffp-contact-strip-inner">' +
            '<div class="ffp-contact-strip-text">' +
              '<strong>Have a question about this policy?</strong>' +
              '<span>Our team responds within 1 business day.</span>' +
            '</div>' +
            '<div class="ffp-contact-strip-btns">' +
              '<a href="/pages/contact" class="ffp-cta-btn">Contact Us</a>' +
              '<a href="mailto:info@furryfable.com" class="ffp-cta-btn ffp-cta-btn--outline">info@furryfable.com</a>' +
            '</div>' +
          '</div>' +
        '</div>' +

      '</div>';

    document.body.classList.add('ffp-policy-active');

    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    container.parentNode.replaceChild(wrapper.firstElementChild, container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
